export const getCookie = (name: string): string | null => `; ${document.cookie}`.split(`; ${name}=`).pop()?.split(';').shift() ?? null;
